import { apiCall } from '@/lib/api';
import { createMutation, useQueryClient } from '@tanstack/solid-query';
import { linkSlack, startSlackLink, unlinkSlack } from './api';

/** Returns the Slack authorize URL; the caller navigates the browser there. */
export const useStartSlackLink = () =>
  createMutation(() => ({
    mutationFn: async () => (await apiCall(startSlackLink, {})).data.url,
  }));

/** Completes the link with the code + state the Slack callback bounced back. */
export const useLinkSlack = () =>
  createMutation(() => ({
    mutationFn: async (body: { code: string; state: string }) =>
      (await apiCall(linkSlack, { body })).data.outcome,
  }));

export const useUnlinkSlack = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: () => apiCall(unlinkSlack, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'me'] }),
  }));
};
